import { Box, Button, CardMedia, Grid, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { NavLink, useParams } from 'react-router-dom';
import bodyLeftBg from '../../../../images/Rectangle 302.png';
import './ShowDetails.css';

const serviceTextBg = {
    backgroundImage: `url(${bodyLeftBg})`,
    backgroundPosition: 'left top',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '30% 80%'
}

const ShowDetails = () => {
    const { serviceId } = useParams();
    const [service, setService] = useState([]);

    useEffect(() => {
        fetch(`https://powerful-wildwood-27860.herokuapp.com/services`)
            .then(res => res.json())
            .then(data => setService(data.services));
    }, [])
    const serviceDetails = service.filter(service => (service._id === serviceId));

    return (
        <Grid container spacing={4}>
            {
                serviceDetails.map(service =>
                    <Box sx={{ textAlign: 'left', py: { xs: 10, sm: 9, md: 8 } }} key={service._id}>
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                            <Box style={serviceTextBg} sx={{ pb: 4 }}>
                                <Box id="details-background" sx={{ textAlign: 'left', ml: { xs: 9, sm: 8, md: 11, lg: 15, xl: 50 } }}>
                                    <Typography sx={{ fontsize: { xs: '20px', sm: '40px', md: '46px' }, pb: 3, color: '#000D83', fontWeight: 600, pl: { xs: 2, sm: 3, md: 4 }, py: 4 }} id="connect-title" variant="h3" component="div">
                                        {service.name}
                                    </Typography>
                                </Box>
                            </Box>
                            <Box sx={{ mx: { xs: 6, sm: 9, md: 12, lg: 16, xl: 50 }, backgroundImage: { sm: `url(${service.topBg})`, md: `url(${service.topBg})`, backgroundRepeat: 'no-repeat', backgroundPosition: 'top center', backgroundSize: '20%', lg: `url(${service.topBg})`, xl: `url(${service.topBg})` } }}>
                                <Typography sx={{ color: '#5B5B5B', pt: 2, pb: { xs: 4, sm: 6, md: 8 }, fontSize: { xs: '14px', sm: '19px', md: '23px' }, lineHight: { md: '45px' } }} variant="body3" component="div">
                                    {service.topDescription}
                                </Typography>
                            </Box>
                            <Box sx={{ mx: { xs: 6, sm: 9, md: 12, lg: 16, xl: 50 }, textAlign: 'left' }}>
                                <Typography sx={{ pt: 2, pl: 2, color: '#000D83', fontSize: { xs: '20px', sm: '38px', md: '46px' }, fontWeight: 600 }} variant="h6" component="div">
                                    Case Study
                                </Typography>
                                <CardMedia
                                    sx={{ mt: 4, mb: 3, width: '100%' }}
                                    id="image-hover"
                                    component="img"
                                    image={service.detailsImg}
                                    alt="green iguana"
                                />
                                <Typography sx={{ color: '#5B5B5B', pb: 3, fontSize: { xs: '14px', sm: '19px', md: '23px' } }} variant="body3" component="div">
                                    {service.firstDescribe}
                                </Typography>
                                <Typography sx={{ color: '#5B5B5B', fontSize: { xs: '14px', sm: '19px', md: '23px' }, pb: 5 }} variant="body3" component="div">
                                    {service.secondDescribe}
                                </Typography>
                                <NavLink to='' style={{ textDecoration: 'none' }}>
                                    <Button sx={{ textDecoration: 'none', fontSize: '18px', lineHeight: '27px', color: "#000D83", fontWeight: 600, width: '150px', height: '42px', border: '1px solid #000D83', mr: 3 }} style={{ textTransform: 'capitalize' }} id="service-button">
                                        Explore <i style={{ paddingLeft: '10px' }} className="fas fa-long-arrow-alt-right"></i>
                                    </Button>
                                </NavLink>
                            </Box>
                        </Grid>
                    </Box>)
            }
        </Grid>
    );
};

export default ShowDetails;